import FormFieldViewBoolean from "components/FormFields/ViewBoolean";
import FormFieldViewText from "components/FormFields/ViewText";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import { WebhooksIntegration } from "types/generated";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";

type StackSettingsIntegrationsWebhooksDetailsProps = {
  webhook: WebhooksIntegration;
};

const StackSettingsIntegrationsWebhooksDetails = createDrawer(
  ({ webhook }: StackSettingsIntegrationsWebhooksDetailsProps) => {
    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Details" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody>
          <FormFieldViewText label="Endpoint" value={webhook.endpoint} />
          <FormFieldViewBoolean label="Enabled" value={webhook.enabled} />
          <FormFieldViewBoolean label="Retry on failure" value={webhook.retryOnFailure} />
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showStackSettingsIntegrationsWebhooksDetails = createDrawerTrigger(
  StackSettingsIntegrationsWebhooksDetails
);
